import React from 'react'
import ReactDOM from 'react-dom'
import ReactMarkdown from 'react-markdown'
import 'whatwg-fetch'

import CompatibilityTable from './compatibility-table'
import '../css/browser-checker.scss'

/**
 * Wait to begin rendering. Works for IE9+.
 */
document.addEventListener('DOMContentLoaded', () => ReactDOM.render(<CompatibilityTable />, document.getElementById('box-table-a'))
)


// WEBPACK FOOTER //
// ./app/index.js